module.exports = __webpack_public_path__ + "static/media/4 5 tattoo forearm vivi nostalgic whimsical magical stellar.1280x1770.dd80bd65.webp";